import React from 'react';
import { Link } from 'react-router-dom';

const Calculators = () => {
  const calculatorTools = [
    {
      id: 'bracelet-calculator',
      name: '手链计算器',
      description: '筋围计算、咪数推荐、珠子计算',
      icon: '🧮',
      path: '/calculators/bracelet-calculator'
    },
    {
      id: 'cost-estimator',
      name: '手链材料成本估算器',
      description: '输入珠子、线材、配件单价和数量，自动计算总成本',
      icon: '💰',
      path: '/calculators/cost-estimator'
    },
    {
      id: 'size-converter',
      name: '手链尺寸换算表',
      description: '厘米 ↔ 英寸 ↔ 法国尺码 即时换算',
      icon: '📏',
      path: '/calculators/size-converter'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-purple-800">
          计算器工具
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {calculatorTools.map((tool) => (
            <Link
              key={tool.id}
              to={tool.path}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-purple-100"
            >
              <div className="text-4xl mb-4">{tool.icon}</div>
              <h2 className="text-xl font-semibold mb-2 text-purple-700">
                {tool.name}
              </h2>
              <p className="text-gray-600">{tool.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Calculators;